import styled from "styled-components";

export const FiltersRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    width: 100%;
`;

export const FilterColumn = styled.div`
    flex: ${props => props.$flex || "1 1 0"};
    min-width: ${props => props.$minWidth || 180}px;
    ${props =>
        props.$capWidth != null
            ? `
        max-width: min(100%, ${props.$capWidth}px);
        @media (max-width: 768px) {
            max-width: 100%;
        }
    `
            : ""}
    & > * > *:first-child {
        min-height: 22px;
    }
`;
